<template>
  <div class="continer">
    <!-- 顶部 -->
    <div class="header">
      <div class="top">
        <!-- 返回 -->
        <div class="back" @click="goBack()">
          <img
            src="@/assets/images/weekly_charts/white_back.png"
            alt=""
            srcset=""
          />
        </div>
        <!-- 切换上一期 -->
        <div class="periods">
          <div
            :class="{
              activate: currentRankId == pageData.current_activity.activity_id,
            }"
            @click="changePeriod(pageData.current_activity.activity_id)"
          >
            本期榜单
          </div>
          <div
            :class="{
              activate: currentRankId == pageData.up_activity.activity_id,
            }"
            @click="changePeriod(pageData.up_activity.activity_id)"
          >
            上期榜单
          </div>
        </div>
      </div>
      <!-- 标题 -->
      <div class="title">
        <img src="@/assets/images/weekly_charts/title.png" alt="" srcset="" />
      </div>
      <!-- 按钮模块 -->
      <div class="button">
        <div class="time">
          冲榜时间：{{ pageData.item_time.activitySpan_time }}
        </div>
        <div class="content">
          <div
            :class="{ activate: rankingType == 'daily' }"
            @click="changeRankingType('daily')"
          >
            日榜
          </div>
          <div
            :class="{ activate: rankingType == 'weekly' }"
            @click="changeRankingType('weekly')"
          >
            周榜
          </div>
        </div>
        <div class="desc">{{ awardGiveTime }}</div>
      </div>
      <!-- 侧标签 -->
      <div class="side-tag">
        <div class="rules" @click="goNewPage('/weekly_charts/rule')">玩法</div>
        <div class="record" @click="goNewPage('/weekly_charts/record')">
          记录
        </div>
      </div>
    </div>
    <!-- 主体 -->
    <div class="main">
      <!-- 游戏推荐 -->
      <div class="game_recommend">
        <div class="top">
          <div class="left">
            <div class="icon"></div>
            <div class="text">推荐游戏</div>
          </div>
          <div class="right" @click="refreshRecommend()">
            <div class="icon" :class="{ animation: gamesRefresh }">
              <img
                src="@/assets/images/weekly_charts/refresh.png"
                alt=""
                srcset=""
              />
            </div>
            <div class="text">换一换</div>
          </div>
        </div>
        <div class="content">
          <div class="games">
            <div class="item" v-for="(item, key) in gameList" :key="key">
              <div class="icon">
                <img :src="item.icon" />
                <span>{{ item.issue }}</span>
              </div>
              <p class="name">{{ item.title }}</p>
              <div class="play" @click="toApp(item.jump_url)">去试玩</div>
            </div>
          </div>
        </div>
        <div class="bottom" @click="goHighEarn()">查看更多任务 ></div>
      </div>
      <!-- 排名 -->
      <div class="ranking">
        <div class="top">
          <div>排名</div>
          <div>用户名</div>
          <div>累计赚取</div>
          <div>获取奖金</div>
        </div>
        <div class="content">
          <div class="item me">
            <div class="row">
              <div class="show_level"></div>
              <div class="left">
                <div class="avatar">
                  <img :src="pageData.item_my.avatar" />
                </div>
                <div class="desc">
                  <div class="nickname">我自己</div>
                  <!-- 累计赚取 -->
                  <div class="total">
                    累计赚取{{ pageData.item_my.integral }}
                  </div>
                </div>
              </div>
              <!-- 获取奖金 -->
              <div class="right">
                <div>{{ rewardDesc.first }}</div>
                <div>{{ rewardDesc.second }}</div>
              </div>
            </div>
          </div>
          <div
            class="item"
            v-for="(item, key) in rankList[page.page - 1]"
            :key="key"
          >
            <div class="row">
              <div
                class="show_level"
                :class="{
                  first: item.level == 1,
                  second: item.level == 2,
                  third: item.level == 3,
                }"
                v-if="item.show_level <= 3"
              ></div>
              <div class="show_level" v-else>{{ item.level }}</div>
              <div class="head">
                <div class="avatar"><img :src="item.avatar" /></div>
                <div class="nickname">{{ item.nickname }}</div>
              </div>
              <!-- 累计赚取 -->
              <div class="integral">{{ item.integral }}</div>
              <!-- 获取奖金 -->
              <div class="reward" @click="getPlayGameList(item.userid)">
                <div class="money">奖{{ item.reward_money }}</div>
                <!-- 图标 -->
                <div
                  class="arrows"
                  :class="{
                    down: playGameList.show[`${item.userid}_${currentRankId}`],
                  }"
                ></div>
              </div>
            </div>
            <!-- 试玩详情 -->
            <div
              class="detail"
              v-if="playGameList.show[`${item.userid}_${currentRankId}`]"
            >
              <div
                class="task"
                v-for="(item, key) in playGameList.data[
                  `${item.userid}_${currentRankId}`
                ]"
                :key="key"
                @click="toApp(item.jump_url)"
              >
                <div class="icon"><img :src="item.ad_imgurl" /></div>
                <div class="task_info">
                  <p>{{ item.ad_name }}</p>
                  <p>{{ item.reward_money }}</p>
                </div>
              </div>
            </div>
            <div class="line"></div>
          </div>
        </div>
        <div class="page_control">
          <div
            class="last button"
            :class="{ disable: !hasBefore }"
            @click="before()"
          ></div>
          <div class="page_num">{{ page.page }}/{{ page.total }}</div>
          <div
            class="next button"
            :class="{ disable: !hasNext }"
            @click="next()"
          ></div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer" @click="goHighEarn()">我要冲榜</div>
    <!-- loading -->
    <loading :isLoad="isLoading"></loading>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Empty, Popup } from 'vant'
import Loading from '@/components/Loading'

Vue.use(Toast)
  .use(Empty)
  .use(Popup)

export default {
  name: 'Weekly',
  components: {
    Loading,
  },
  data() {
    return {
      // 用户信息
      userId: '',
      deviceId: '',
      appVersion: '',
      // 当前活动id
      currentRankId: '',
      // 榜单类型
      rankingType: 'daily',
      gamesRefresh: false,
      // 加载状态
      isLoading: false,
      // 页面数据
      pageData: {
        up_activity: {},
        current_activity: {},
        item_my: {},
        // 最后一名
        item_last: {
          integral: 0,
        },
        item_time: {},
      },
      page: {
        page: 1,
        total: 40,
      },
      gameList: [],
      // 榜单数据
      rankList: {},
      // 奖励规则
      rewardRules: {
        data: [],
        // 描述
        describe: '',
      },
      playGameList: {
        show: {},
        data: {},
      },
    }
  },
  computed: {
    hasBefore: function() {
      return this.page.page == 1 ? false : true
    },
    hasNext: function() {
      return this.page.page == this.page.total ? false : true
    },
    // 我的奖励描述
    rewardDesc: function() {
      const info = {
        first: '暂无奖励',
        second: '距上榜差0元',
      }

      if (this.$g.isEmptyObject(this.pageData.item_my)) {
        return info
      }

      console.log(this.pageData.item_my)

      if (this.pageData.item_my.status == 1) {
        info.first = `预估奖励:${this.pageData.item_my.reward_money}`
        const chineseNum = this.$g.numberToChineseSimple(
          this.pageData.item_my.level
        )
        info.second = `当前排名:第${chineseNum}名`
      } else {
        // 计算差额
        const myIntegral = Number(
          this.pageData.item_my.integral.replace('元', '')
        )
        const diffMoney = Math.round(
          Number(this.pageData.item_last.integral) + 1 - myIntegral
        )

        info.second = `距上榜差${diffMoney}元`
      }
      return info
    },
    // 发奖时间
    awardGiveTime: function() {
      if (this.rankingType == 'daily') {
        return '每天0点5分发奖，每10分钟刷新榜单'
      } else {
        return '每周一10点，审核后发放至余额'
      }
    },
  },
  created() {
    this.userId = this.getCookie('userid')
    this.deviceId = this.getCookie('device_id')
    this.appVersion = this.getCookie('app_version')
    if (!this.userId) {
      this.userId = this.$route.query.user_id
      this.deviceId = this.$route.query.device_id
      this.appVersion = this.$route.query.app_version
    }
    this.getPageData()
  },
  methods: {
    getCookie: function(name) {
      var strcookie = document.cookie //获取cookie字符串
      var arrcookie = strcookie.split('; ') //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split('=')
        if (arr[0] == name) {
          return arr[1]
        }
      }
      return ''
    },
    callClienFunc: function(fname, fval) {
      if (window.hasOwnProperty('injectedObject')) {
        window.injectedObject.setJsContent(fname, fval)
      } else {
        fval = fval ? fval : {}
        let params = { method: fname, params: fval }
        params = JSON.stringify(params)
        window.Android.postMessage(params)
      }
    },
    goBack() {
      this.callClienFunc('closeWebview', '')
    },
    // 去试玩
    toApp: function(url) {
      window.location.href = url
    },
    // 跳转高额赚
    goHighEarn: function() {
      this.toApp('lezhuan://jump?type=1&content={"index":"1"}')
    },
    before: function() {
      this.page.page = this.page.page - 1 >= 1 ? this.page.page - 1 : 1
    },
    next: function() {
      this.page.page =
        this.page.page + 1 <= this.page.total
          ? this.page.page + 1
          : this.page.total
    },
    // 跳转玩法|记录
    goNewPage(url) {
      this.$router.push({
        path: url,
        query: {
          user_id: this.userId,
          device_id: this.deviceId,
          app_version: this.appVersion,
        },
      })
    },
    // 获取试玩游戏数据
    getPlayGameList(userid) {
      const key = `${userid}_${this.currentRankId}`
      // 设置状态
      this.setShowStatus(key)
      if (this.playGameList.data.hasOwnProperty(key)) {
        return
      }

      let params = {
        activity_id: this.currentRankId,
        app_version: this.appVersion,
        play_userid: userid,
        userid: this.userId,
        device_id: this.deviceId,
      }
      this.isLoading = true
      this.$http
        .get('/api/user_web/show_activity_ad', { params: params })
        .then((res) => {
          this.$set(this.playGameList.data, key, res.data)
          // 设置状态
          this.setShowStatus(key)
          this.isLoading = false
        })
    },
    // 设置状态
    setShowStatus(cacheKey) {
      // 关闭其他人
      for (let key in this.playGameList.show) {
        if (key == cacheKey) {
          continue
        }
        this.$set(this.playGameList.show, key, false)
      }
      // 无数据
      if (!this.playGameList.data.hasOwnProperty(cacheKey)) {
        return
      }
      if (!this.playGameList.show.hasOwnProperty(cacheKey)) {
        // 打开自己
        this.$set(this.playGameList.show, cacheKey, true)
      } else {
        this.$set(
          this.playGameList.show,
          cacheKey,
          !this.playGameList.show[cacheKey]
        )
      }
    },
    // 切换上下期
    changePeriod(activity_id) {
      if (!activity_id || this.currentRankId == activity_id) {
        return
      }
      this.currentRankId = activity_id
      this.getPageData('period')
    },
    // 切换榜单类型
    changeRankingType(type) {
      if (!type || this.rankingType == type) {
        return
      }
      // 清空活动id
      this.currentRankId = ''
      this.rankingType = type
      this.getPageData()
    },
    // 刷新推荐列表
    refreshRecommend() {
      this.gamesRefresh = true

      const params = {
        app_version: this.appVersion,
        userid: this.userId,
        device_id: this.deviceId,
      }
      this.$http
        .get('/api/user_web/refresh_activity_ad', { params: params })
        .then((res) => {
          // 设置数据
          this.gameList = res.data.list
          this.gamesRefresh = false
        })
    },
    // 获取页面数据
    getPageData(type = 'ranking') {
      const params = {
        app_version: this.appVersion,
        userid: this.userId,
        device_id: this.deviceId,
        activity_type: 1, // 1:周榜 3:日榜
      }
      this.isLoading = true
      // 日榜|周榜 数据
      if (this.rankingType == 'daily') {
        params.activity_type = 3
      }
      // 传入id
      if (this.currentRankId != '') {
        params.activity_id = this.currentRankId
      }
      this.$http
        .get('/api/user_web/show_activity_by_type', { params: params })
        .then((res) => {
          // 设置数据
          this.setItem(res.data.list, type)
          this.isLoading = false
        })
    },
    setItem(config, type) {
      Object.keys(config).forEach((key) => {
        switch (true) {
          // 推荐游戏
          case config[key].itemCategory == 'item_recommend_ad':
            this.gameList = config[key].recommend_ad
            break
          // 试玩排名说明
          case config[key].itemCategory == 'item_top':
            this.rewardRules.data = config[key].item_list
            break
          // 奖励规则说明
          case config[key].itemCategory == 'item_text':
            this.rewardRules.describe = this.htmlspecialcharsDecode(
              config[key].text
            )
            break
          // 榜单数据配置
          case config[key].itemCategory == 'item_data_day':
          case config[key].itemCategory == 'item_data_week':
            // 页码信息
            this.page = {
              page: 1,
              total: Math.ceil(config[key].item_list.length / 10),
            }
            // 榜单用户列表
            this.rankList = config[key].item_list.reduce(
              (result, item, index) => {
                if (index % 10 === 0) {
                  result.push([])
                }
                result[result.length - 1].push(item)
                return result
              },
              []
            )
            // 我的上榜记录
            var grantStatus = 0
            if (config[key].my_level.is_receive == 2) {
              grantStatus = 1 // 待领取
            } else if (
              config[key].my_level.is_receive == 1 &&
              config[key].my_level.grant_state == 1
            ) {
              grantStatus = 2 // 审核中
            } else if (
              config[key].my_level.is_receive == 1 &&
              config[key].my_level.grant_state == 2
            ) {
              grantStatus = 3 // 已发放
            }
            this.pageData.item_my = {
              avatar: config[key].my_level.avatar,
              reward_money: config[key].my_level.reward_money,
              integral: config[key].my_level.integral,
              status: Number(config[key].my_level.my_up_level),
              nickname: config[key].my_level.nickname,
              level: config[key].my_level.my_level,
              grant_status: grantStatus,
            }

            if (this.rankList.length == 0) {
              break
            }
            // 记录最后一名
            this.pageData.item_last =
              config[key].item_list[config[key].item_list.length - 1]
            break
          // 榜单相关配置
          case config[key].itemCategory == 'item_stage':
            // 当前期
            if (
              type != 'period' &&
              config[key].item_stage.hasOwnProperty('current_activity')
            ) {
              this.pageData.current_activity =
                config[key].item_stage.current_activity
              this.currentRankId =
                config[key].item_stage.current_activity.activity_id
            }
            // 上一期
            if (type != 'period') {
              if (config[key].item_stage.hasOwnProperty('up_activity')) {
                this.pageData.up_activity = config[key].item_stage.up_activity
              } else {
                this.pageData.up_activity = { activity_id: '' }
              }
            }
            break
          // 活动及其榜单时间
          case config[key].itemCategory == 'item_time':
            this.pageData.item_time = config[key]
            break
        }
      })
    },
    htmlspecialcharsDecode: function(str) {
      var s = ''
      if (str.length == 0) return ''
      s = str.replace(/&amp;/g, '&')
      s = s.replace(/&lt;/g, '<')
      s = s.replace(/&gt;/g, '>')
      s = s.replace(/&nbsp;/g, ' ')
      return s
    },
  },
}
</script>

<style lang="less" scoped>
.continer {
  max-width: inherit;
  font-family: PingFangSC-Medium;
  position: relative;
  background: #ffe1e1;
  min-height: 100vh;

  .header {
    height: 2.2rem;
    padding-top: 0.4rem;
    background: url('~@/assets/images/weekly_charts/header.png') no-repeat
      center;
    background-size: 100% 100%;

    .top {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 0.2rem;
      position: relative;

      .periods {
        width: 1.76rem;
        height: 0.26rem;
        line-height: 0.26rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #9b000e;
        border-radius: 0.26rem;
        font-size: 0.14rem;
        color: #ffffff;

        div {
          flex: 1;
          height: 100%;
          text-align: center;
          border-radius: inherit;
        }

        .activate {
          background: #fff;
          color: #ac0b18;
        }
      }

      .back {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 0.44rem;
        height: 0.33rem;
        position: absolute;
        left: 0;
        z-index: 999;

        img {
          width: 0.14rem;
        }
      }
    }

    .title {
      width: 2.64rem;
      margin: 0 auto;

      img {
        width: 100%;
      }
    }

    .button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .time {
        font-size: 0.12rem;
        color: #ffffff;
      }

      .content {
        display: flex;
        align-items: center;
        justify-content: center;
        background: url('~@/assets/images/weekly_charts/button_bg.png')
          no-repeat center;
        background-size: 100% 100%;
        width: 2.8rem;
        height: 0.6rem;
        font-size: 0.14rem;
        font-weight: 600;
        color: #ffffff;
        margin: 0.06rem 0;

        div {
          height: 0.44rem;
          line-height: 0.44rem;
          text-align: center;
          width: 47%;
        }

        .activate {
          color: #ac0b18;
          background: url('~@/assets/images/weekly_charts/button.png') no-repeat
            center;
          background-size: 100% 100%;
        }
      }

      .desc {
        font-size: 0.12rem;
        color: #ad0e1b;
        text-shadow: 0 0.01rem 0 rgba(255, 255, 255, 0.6);
        font-weight: 600;
      }
    }

    .side-tag {
      .rules,
      .record {
        display: flex;
        align-items: center;
        width: 0.24rem;
        height: 0.48rem;
        position: absolute;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 0.06rem 0 0 0.06rem;
        font-size: 0.16rem;
        color: #ffffff;
        text-align: center;
        line-height: 0.18rem;
        font-weight: 400;
      }

      .rules {
        top: 0.64rem;
        right: 0;
      }

      .record {
        top: 1.4rem;
        right: 0;
      }
    }
  }

  .main {
    padding: 0 0.08rem;
    padding-top: 0.2rem;
    padding-bottom: 0.8rem;
    // background: #ffe1e1;

    .game_recommend {
      // height: 3.68rem;
      background: #ffffff;
      border-radius: 0.1rem;
      padding-bottom: 0.04rem;
      margin-bottom: 0.08rem;

      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 0.46rem;
        border-bottom: 0.01rem solid #f2f2f2;
        padding: 0 0.2rem;

        .left {
          display: flex;
          align-items: center;
          .icon {
            width: 0.04rem;
            height: 0.12rem;
            background: #ff5032;
            border-radius: 0.01rem;
          }

          .text {
            margin-left: 0.12rem;
            font-size: 16px;
            color: #333333;
          }
        }

        .right {
          display: flex;
          align-items: center;
          .icon {
            width: 0.14rem;
            height: 0.14rem;
            animation: rotate 2s ease-in-out infinite;
            animation-play-state: paused;

            img {
              width: 100%;
            }
          }

          .icon.animation {
            animation-play-state: running;
          }

          /** 旋转动画 */
          @keyframes rotate {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

          .text {
            margin-left: 0.06rem;
            font-size: 14px;
            color: #2d94ff;
          }
        }
      }

      .content {
        padding: 0 0.2rem;

        .games {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          grid-gap: 0.16rem;
          margin-top: 0.16rem;

          .item {
            display: block;
            width: 0.56rem;
            margin: 0 0.048rem;
            margin-bottom: 0.24rem;
            font-size: 0.12rem;
            overflow: hidden;

            .icon {
              display: block;
              position: relative;
              width: 0.56rem;
              height: 0.56rem;
              margin-bottom: 0.06rem;
              overflow: hidden;

              img {
                width: 100%;
                border-radius: 0.1rem;
              }
              span {
                position: absolute;
                bottom: 0;
                right: 0;
                padding: 0.01rem 0.02rem;
                display: block;
                min-width: 0.24rem;
                text-align: center;
                color: #d5a892;
                background: url('~@/assets/images/weekly_charts/mark.png')
                  no-repeat;
                background-size: 100% 100%;
              }
            }
            .name {
              white-space: nowrap;
              text-overflow: ellipsis;
              text-align: center;
              margin-bottom: 0.06rem;
              overflow: hidden;
              color: #333333;
            }
            .play {
              display: block;
              height: 0.26rem;
              text-align: center;
              line-height: 0.26rem;
              background-image: linear-gradient(
                90deg,
                #ff0000 0%,
                #ff8831 100%
              );
              border-radius: 0.14rem;
              color: #ffffff;
              overflow: hidden;
              margin: 0 auto;
            }
          }
        }
      }

      .bottom {
        font-size: 0.14rem;
        color: #333333;
        height: 0.3rem;
        line-height: 0.3rem;
        text-align: center;
        background: #fafafa;
        border-radius: 0 0 0.08rem 0.08rem;
        margin: 0 0.04rem;
      }
    }

    .ranking {
      background: #ffffff;
      border-radius: 0.1rem;
      padding-bottom: 0.04rem;

      .top {
        display: grid;
        height: 0.38rem;
        align-items: center;
        justify-items: center;
        grid-template-columns: repeat(4, 1fr);
        background: #fafafa;
        border-radius: 0.08rem 0.08rem 0 0;
        margin: 0.04rem;

        div {
          margin-right: 0.2rem;

          &:nth-child(1),
          &:nth-child(2) {
            margin-right: 0.4rem;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }

      .content {
        padding: 0 0.04rem;

        .item {
          display: block;
          background: #ffffff;
          overflow: hidden;

          .row {
            height: 0.52rem;
            display: grid;
            grid-template-columns: 0.6rem 1rem repeat(2, 1fr);
            align-items: center;
            justify-items: center;

            .show_level {
              display: block;
              min-width: 0.28rem;
              height: 0.24rem;
              text-align: center;
              line-height: 0.24rem;
              margin-right: 0.13rem;
              // margin-left: 0.12rem;
              font-size: 0.14rem;
              font-weight: 550;
              color: #333333;
              overflow: hidden;
            }
            .first {
              display: block;
              width: 0.24rem;
              height: 0.24rem;
              background: url('~@/assets/images/ranking_shouyou/rank_first.png')
                no-repeat;
              background-size: 0.24rem 0.24rem;
              background-position: center;
              overflow: hidden;
            }
            .second {
              display: block;
              width: 0.24rem;
              height: 0.24rem;
              background: url('~@/assets/images/ranking_shouyou/rank_second.png')
                no-repeat;
              background-size: 0.24rem 0.24rem;
              background-position: center;
              overflow: hidden;
            }
            .third {
              display: block;
              width: 0.24rem;
              height: 0.24rem;
              background: url('~@/assets/images/ranking_shouyou/rank_third.png')
                no-repeat;
              background-size: 0.24rem 0.24rem;
              background-position: center;
              overflow: hidden;
            }

            .head {
              display: flex;
              align-items: center;
              justify-self: flex-start;

              .avatar {
                width: 0.24rem;
                height: 0.24rem;
                border-radius: 100%;
                background: #000;
                margin-right: 0.06rem;
                overflow: hidden;

                img {
                  width: 100%;
                }
              }

              .nickname {
                max-width: 0.76rem;
                font-size: 0.14rem;
                color: #333333;
                // 超出省略
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            .integral {
              font-size: 0.12rem;
              color: #333333;
              // 超出省略
              max-width: 0.8rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-weight: 500;
            }

            .reward {
              display: flex;
              align-items: center;

              .money {
                font-size: 0.14rem;
                color: #ff5032;
                text-align: right;
                font-weight: 600;
              }

              .arrows {
                width: 0.1rem;
                height: 0.1rem;
                margin-left: 0.04rem;
                background: url('~@/assets/images/weekly_charts/arrows_right.png');
                background-size: 100% 100%;
                overflow: hidden;
              }

              .arrows.down {
                transform: rotate(90deg);
              }
            }
          }

          .detail {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            margin-left: 0.6rem;
            width: 2.48rem;
            background: #fafafa;
            border-radius: 0 0 0.1rem 0.1rem;
            padding: 0.1rem 0.18rem;

            .task {
              display: flex;
              width: 1.4rem;
              height: 0.3rem;
              margin-bottom: 0.12rem;

              .icon {
                width: 0.3rem;
                height: 0.3rem;
                border-radius: 0.05rem;

                img {
                  width: 100%;
                  border-radius: 0.05rem;
                }
              }
              .task_info {
                display: flex;
                margin-left: 0.08rem;
                width: 0.82rem;
                height: 0.3rem;
                flex-direction: column;
                justify-content: space-around;
                white-space: nowrap;
                overflow: hidden;

                p {
                  display: block;
                  width: 0.82rem;
                  height: 0.15rem;
                  line-height: 0.15rem;
                  font-size: 0.12rem;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
                p:first-child {
                  color: #999999;
                }
                p:last-child {
                  color: #ff5032;
                }
              }
            }
          }

          .line {
            display: block;
            float: right;
            width: 2.55rem;
            border-top: 0.01rem rgb(250, 250, 250) solid;
            margin-right: 0.12rem;
          }
        }

        .item.me {
          background: #fff3de;
          border-radius: 0.1rem;

          .row {
            grid-template-columns: 0.6rem repeat(2, 1fr);

            .left {
              display: flex;
              align-items: center;
              justify-self: flex-start;

              .avatar {
                width: 0.24rem;
                height: 0.24rem;
                border-radius: 100%;
                background: #000;
                margin-right: 0.06rem;
                overflow: hidden;

                img {
                  width: 100%;
                }
              }

              .desc {
                .nickname {
                  font-size: 0.14rem;
                  color: #999999;
                }

                .total {
                  font-size: 0.12rem;
                  color: #333333;
                  font-weight: 500;
                }
              }
            }

            .right {
              justify-self: flex-end;
              padding-right: 0.16rem;
              text-align: end;

              div:first-child {
                font-size: 0.14rem;
                color: #ff5032;
                font-weight: 600;
              }

              div:last-child {
                font-size: 0.12rem;
                color: #ad0e1b;
              }
            }
          }
        }
      }

      .page_control {
        display: grid;
        height: 0.38rem;
        align-items: center;
        justify-items: center;
        grid-template-columns: repeat(3, 1fr);
        background: #fafafa;
        border-radius: 0 0 0.08rem 0.08rem;
        margin: 0.04rem;
        padding: 0 0.16rem;

        .page_num {
          font-size: 0.14rem;
        }

        .button {
          width: 0.25rem;
          height: 0.25rem;
        }

        .last {
          justify-self: flex-start;
          background-image: url('~@/assets/images/weekly_charts/page_left.png');
          background-size: 100% 100%;
        }

        .next {
          justify-self: flex-end;
          background-image: url('~@/assets/images/weekly_charts/page_right.png');
          background-size: 100% 100%;
        }

        .last.disable {
          background-image: url('~@/assets/images/weekly_charts/page_left_disabled.png');
        }

        .next.disable {
          background-image: url('~@/assets/images/weekly_charts/page_right_disabled.png');
        }
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 0.1rem;
    left: 50%;
    transform: translateX(-50%);
    width: 3.26rem;
    height: 0.48rem;
    line-height: 0.48rem;
    background-image: linear-gradient(270deg, #ff1f27 0%, #ff8e3f 100%);
    border-radius: 0.24rem;

    font-size: 0.16rem;
    color: #ffffff;
    text-align: center;
    font-weight: 500;
  }
}
</style>
